import { render, staticRenderFns } from "./HomeHealthcareServiceDetails.vue?vue&type=template&id=4c737513&scoped=true"
import script from "./HomeHealthcareServiceDetails.vue?vue&type=script&lang=ts"
export * from "./HomeHealthcareServiceDetails.vue?vue&type=script&lang=ts"
import style0 from "./HomeHealthcareServiceDetails.vue?vue&type=style&index=0&id=4c737513&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c737513",
  null
  
)

export default component.exports